import { render, staticRenderFns } from "./VerifyIdentity.vue?vue&type=template&id=3171cb91"
import script from "./VerifyIdentity.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyIdentity.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports